import Vue from "vue";
import VueI18n from "vue-i18n";
import vueDebounce from "vue-debounce";
import Vuex from "vuex";
import { initI18n } from "./init-i18n";

export const initVue = function(options, locale, currency, messages) {
  Vue.use(VueI18n);
  Vue.use(vueDebounce);
  Vue.use(Vuex);

  return new Vue({
    store: new Vuex.Store({}),
    i18n: initI18n(locale, currency, messages),
    ...options
  });
};
